import type { BackofficeFindSitePhotosResponse } from "~infrastructure/api/backoffice/contract/site/responses/backoffice-find-site-photos-response.ts";

import { ESitePhotoType, type SitePhoto } from "~domain/sites/models/site-photo-model.ts";

export const SitePhotoMapper = {
  fromBackofficeSitePhotosToDomain(backofficeSitePhotos: BackofficeFindSitePhotosResponse): Array<SitePhoto> {
    return backofficeSitePhotos.map(SitePhotoMapper.fromBackofficeSitePhotoToDomain);
  },
  fromBackofficeSitePhotoToDomain(backofficeSitePhoto: BackofficeFindSitePhotosResponse[number]): SitePhoto {
    return {
      id: backofficeSitePhoto.id,
      siteId: backofficeSitePhoto.siteId,
      creationDateTime: backofficeSitePhoto.creationDateTime,
      uploadDateTime: backofficeSitePhoto.uploadDateTime,
      url: backofficeSitePhoto.url,
      filename: backofficeSitePhoto.fileName,
      hash: backofficeSitePhoto.hash,
      type: SitePhotoMapper.fromBackofficeSitePhotoTypeToDomain(backofficeSitePhoto.photoTypeRefId),
      metadata: {
        deviceSerial: backofficeSitePhoto.deviceSerial ?? undefined,
        modulator:
          backofficeSitePhoto.hwModulatorId === null
            ? undefined
            : {
                csId: backofficeSitePhoto.csModulatorId ?? undefined,
                hwId: backofficeSitePhoto.hwModulatorId ?? undefined,
              },
        pilot:
          backofficeSitePhoto.hwMomboxId === null
            ? undefined
            : {
                hwId: backofficeSitePhoto.hwMomboxId,
              },
        person:
          backofficeSitePhoto.personId === null
            ? undefined
            : {
                id: backofficeSitePhoto.personId,
                firstName: backofficeSitePhoto.personFirstName ?? undefined,
                lastName: backofficeSitePhoto.personLastName ?? undefined,
              },
      },
    };
  },
  fromBackofficeSitePhotoTypeToDomain(
    backofficeSitePhotoType: BackofficeFindSitePhotosResponse[number]["photoTypeRefId"],
  ): ESitePhotoType {
    const mapping: Record<number, ESitePhotoType> = {
      1: ESitePhotoType.DELIVERY_POINT,
      2: ESitePhotoType.CONTRACT,
      3: ESitePhotoType.BEFORE_INSTALL_CLOSED,
      4: ESitePhotoType.BEFORE_INSTALL_OPENED,
      5: ESitePhotoType.AFTER_INSTALL_CLOSED,
      6: ESitePhotoType.AFTER_INSTALL_OPENED,
      7: ESitePhotoType.OTHER,
      8: ESitePhotoType.RADIATORS,
      9: ESitePhotoType.INSTALLATION_SHEET_VOLTA_PAP,
      10: ESitePhotoType.ELECTRICAL_BOARD,
      11: ESitePhotoType.INSTALLATION_SHEET_VOLT_INSTALL,
      12: ESitePhotoType.CASKET,
      13: ESitePhotoType.INSTALL_BEFORE_INSTALL,
      14: ESitePhotoType.INSTALL_AFTER_WIRING,
      15: ESitePhotoType.INSTALL_AFTER_REASSEMBLY,
      16: ESitePhotoType.UNINSTALL_BEFORE_UNINSTALL,
      17: ESitePhotoType.UNINSTALL_AFTER_REASSEMBLY,
      18: ESitePhotoType.BEFORE_WIRING,
      19: ESitePhotoType.INITIAL_INVENTORY,
      20: ESitePhotoType.NEW_IMPORT_INSTALLATION_SHEET,
      21: ESitePhotoType.APPOINTMENT_COMMITMENT_FORM,
      22: ESitePhotoType.ELECTRICITY_BILL,
      23: ESitePhotoType.CEE_QUOTE,
      24: ESitePhotoType.PROGRAMMING_MODE_STICKER,
      25: ESitePhotoType.WIRE_MODE,
      26: ESitePhotoType.NAME_PLATE,
      27: ESitePhotoType.ELECTRICAL_BOARD_AND_HOUSING,
      28: ESitePhotoType.RADIATORS_AND_TOWEL_DRYERS,
      29: ESitePhotoType.HOT_WATER_TANK,
    };

    return mapping[backofficeSitePhotoType] ?? ESitePhotoType.UNKNOWN;
  },
};
